import ControlFactory from '@/Factories/ControlFactory';
import AssociationBoxViewModel from '@/ViewModels/Controls/AssociationBoxViewModel';
import AssociationBox from '@/Controls/AssociationBox';
import AssociationBoxViewModelT from '@/ViewModels/Controls/AssociationBoxViewModel';
import TextBoxViewModelT from '@/ViewModels/Controls/TextBoxViewModel';
import HiddenViewModelT from '@/ViewModels/Controls/HiddenViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import TypeSelectorWindowViewModelT from '@/ViewModels/Controls/TypeSelectorWindowViewModel';
import SearchListViewViewModelT from '@/ViewModels/Views/SearchListViewViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import NavigationService from '@/Management/NavigationService';
import RADApplication from '@/Management/RADApplication';
import Config from '@/Management/GlobalConfiguration';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
export default class BaseTypeSelectorFactory extends ControlFactory {
    /** Overrides */
    public control: AssociationBox;
    /** Overrides */
    public viewModel: AssociationBoxViewModel;
    private jQueryControl: JQuery;
    public pdTypeName: string;
    private AssociationBoxViewModel: any;
    private TextBoxViewModel: any;
    private HiddenViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    private TypeSelectorWindowViewModel: any;
    private AssociationBox: any;
    private TypeSelectorWindow: any;
    private SearchListViewViewModel: any;
    protected LabelViewModel: any;
    private objectIdentValue: any;
    private pdoId: any;
    private viewFactorySearchListView: any;
    private _selectBaseObjectWindowViewModel: any;
    constructor(params: any) {
        super(params);
        this.jQueryControl = null;
        this.AssociationBoxViewModel = ComponentManager.getViewModel<typeof AssociationBoxViewModelT>('AssociationBoxViewModel');
        this.TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModelT>('TextBoxViewModel');
        this.HiddenViewModel = ComponentManager.getViewModel<typeof HiddenViewModelT>('HiddenViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.TypeSelectorWindowViewModel = ComponentManager.getViewModel<typeof TypeSelectorWindowViewModelT>('TypeSelectorWindowViewModel');
        this.AssociationBox = ComponentManager.getControl('AssociationBox');
        this.TypeSelectorWindow = ComponentManager.getControl('TypeSelectorWindow');
        this.SearchListViewViewModel = ComponentManager.getViewModel<typeof SearchListViewViewModelT>('SearchListViewViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.objectIdentValue = this.context.genericObject.getObservable(this.detailViewItem.name + '.ObjectIdentValue');
        this.pdoId = this.context.genericObject.getObservable(this.detailViewItem.name + '.PDO_ID');
        this.viewFactorySearchListView = null;
        this._selectBaseObjectWindowViewModel = null;
        this.pdTypeName = this.paramOrDefault(params.pdTypeName, null);
    }
    /** Overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.PDO_ID');
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.ObjectIdentValue');
        this.viewModel = (() => {
            return new this.AssociationBoxViewModel({
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                isValid: this.isValid,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                textBox: new this.TextBoxViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name,
                    value: this.objectIdentValue,
                    isEnabled: false,
                    isFocusable: this.isFocusable,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText
                }),
                hidden: new this.HiddenViewModel({
                    value: this.pdoId
                }),
                linkCreate: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.create',
                    tooltip: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.create.image',
                        source: Config.inlineImages.OBJ_CREATE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        this.context.createContext(this, this.detailViewItem.listView);
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkSelect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.select',
                    tooltip: new this.LabelViewModel({
                        ergName: 'FIND_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.select.image',
                        source: Config.inlineImages.OBJ_SELECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'FIND_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        if (this.pdTypeName == null) {
                            this._selectBaseObjectWindowViewModel = this.TypeSelectorWindowViewModel.createBaseTypeSelectorWindow(
                                this.detailViewItem.listView.types,
                                this.showSearchListView,
                                [this.locator, this.detailViewItem.name].filter((s: string) => { return !String.isNullOrEmpty(s); }).join('.'),
                                () => {
                                    NavigationService.getInstance().cleanRegion('Modal');
                                }
                            );
                            let selectBaseObjectWindow = new this.TypeSelectorWindow(this._selectBaseObjectWindowViewModel);
                            let tuple = selectBaseObjectWindow.getTuple();
                        } else {
                            this.showSearchListView(this.pdTypeName);
                        }
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonSelect;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkEdit: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.edit',
                    tooltip: new this.LabelViewModel({
                        ergName: 'EDIT_CONNECTED_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.edit.image',
                        source: Config.inlineImages.OBJ_EDIT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'EDIT_CONNECTED_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.pdoId() != null && this.pdoId() != this.detailViewItem.disableNavigation;
                    }),
                    onClick: () => {
                        this.context.createContext(this, this.detailViewItem.listView, this.pdoId());
                    },
                    isFocusable: this.isFocusable,
                    isVisible: this.detailViewItem.listView.showButtonEdit,
                    isToolBarLink: true
                }),
                linkDisconnect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.disconnect',
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.disconnect.image',
                        source: Config.inlineImages.OBJ_DISCONNECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.pdoId() != null;
                    }),
                    onClick: this.disconnect.bind(this),
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDisconnect;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkDelete: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.delete',
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.delete.image',
                        source: Config.inlineImages.OBJ_DELETE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.pdoId() != null;
                    }),
                    onClick: () => {
                        RADEnvironmentProxy.getInstance().tryToDeleteObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoIDs: [this.pdoId()]
                        }).then((tryDeletion) => {
                            if (!this.validateStatus(tryDeletion))
                                return undefined;

                            return $.when(this.context.notifyBeforeUpdatedAssociation(
                                this.detailViewItem.listView.relationName,
                                'disconnectAndDelete', {toPdoIds: [this.pdoId()]}))
                                .then((doUpdateAssociation) => {
                                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                        return RADEnvironmentProxy.getInstance().deleteObject({
                                            pdTypeName: this.detailViewItem.listView.typeName,
                                            pdoID: this.pdoId()
                                        });
                                    }
                                    return undefined;
                                });
                        }).then((changeObject) => {
                            if (this.validateStatus(changeObject)) {
                                this.pdoId(null);
                                this.objectIdentValue(null);
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            }
                        });
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDelete;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                })
            });
        })();
        this.control = (() => {
            return new this.AssociationBox(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerDefaultValidation([this.detailViewItem.name + '.PDO_ID', this.detailViewItem.name + '.ObjectIdentValue']);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        let associationName = this.detailViewItem.listView.relationName;
        $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'connect', { toPdoIds: [toPDOID] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    RADEnvironmentProxy.getInstance().getPropertiesForDetailViewContext({
                        detailViewContextID: this.context.id,
                        pdoID: this.context.genericObject.pdoId,
                        properties: [this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']
                    }).then((properties) => {
                        if (this.validateStatus(properties)) {
                            this.pdoId(properties.returnValue[this.detailViewItem.name + '.PDO_ID']);
                            this.objectIdentValue(properties.returnValue[this.detailViewItem.name + '.ObjectIdentValue']);
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(associationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        }
                    });
                }
            });
    }
    public disconnect(): void {
        if (this.pdoId() != null) {
            RADEnvironmentProxy.getInstance().tryToDisconnectObject({
                pdoID: this.context.genericObject.pdoId,
                assoziationName: this.detailViewItem.listView.relationName,
                topdTypeName: this.detailViewItem.listView.typeName,
                pdoIDs: [this.pdoId()]
            }).then((tryDeletion) => {
                if (!this.validateStatus(tryDeletion))
                    return undefined;

                return $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName,
                    'disconnect', {toPdoIds: [this.pdoId()]}))
                    .then((doUpdateAssociation) => {
                        if (doUpdateAssociation == null || doUpdateAssociation === true) {
                            return RADEnvironmentProxy.getInstance().disconnect({
                                pdoID: this.context.genericObject.pdoId,
                                assoziationName: this.detailViewItem.listView.relationName,
                                topdTypeName: this.detailViewItem.listView.typeName,
                                toPDOID: this.pdoId(),
                                nestedContextName: this.context.getNestedContextPath()
                            });
                        }
                        return undefined;
                    });
            }).then((changeObject) => {
                if (this.validateStatus(changeObject)) {
                    this.pdoId(null);
                    this.objectIdentValue(null);
                    this.context.genericObject.isModified(true);
                    this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                }
            });
        }
    }
    /** Overrides */
    protected disposeInternal(): void {
        if (this._selectBaseObjectWindowViewModel && !this._selectBaseObjectWindowViewModel.isDisposed) {
            this._selectBaseObjectWindowViewModel.dispose();
        }
        if (this.viewFactorySearchListView != null && !this.viewFactorySearchListView.isDisposed) {
            NavigationService.getInstance().removeViewFactory(this.viewFactorySearchListView);
        }
        super.disposeInternal();
    }
    private showSearchListView(pdTypeName: any): any {
        RADEnvironmentProxy.getInstance().getListViewByName({
            listViewName: pdTypeName + '_LV'
        }).then((listView) => {
            if (this.viewFactorySearchListView != null) {
                return;
            }
            this.viewFactorySearchListView = NavigationService.getInstance().loadViewFactoryIsolated('SearchListView', {
                viewModel: new this.SearchListViewViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.search-view',
                    listView: listView,
                    contextPdoId: this.context.genericObject.pdoId,
                    allowMultiSelect: false,
                    callback: (toPDOIDs) => {
                        if (+this.context.genericObject.pdoId > 0) {
                            $.when(this.context.notifyBeforeUpdatedAssociation(
                                this.detailViewItem.listView.relationName,
                                'connect', { toPdoIds: toPDOIDs }))
                                .then((doUpdateAssociation) => {
                                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                        RADEnvironmentProxy.getInstance().connect({
                                            pdoID: this.context.genericObject.pdoId,
                                            assoziationName: this.detailViewItem.listView.relationName,
                                            topdTypeName: this.pdTypeName,
                                            toPDOID: toPDOIDs[0],
                                            nestedContextName: this.context.getNestedContextPath()
                                        }).then((changeObject) => {
                                            if (this.validateStatus(changeObject)) {
                                                this.pdoId(toPDOIDs[0]);
                                                this.objectIdentValue(changeObject.returnValue);
                                                this.context.genericObject.isModified(true);
                                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                                            }
                                        });
                                    }
                                });
                        } else {
                            RADEnvironmentProxy.getInstance().getObject({
                                pdTypeName: this.detailViewItem.listView.typeName,
                                pdoID: toPDOIDs[0],
                                properties: ['ObjectIdentValue']
                            }).then((genericDTO) => {
                                this.pdoId(toPDOIDs[0]);
                                this.objectIdentValue(genericDTO.objectIdentValue);
                            });
                        }
                    },
                    onClose: () => {
                        NavigationService.getInstance().removeViewFactoryIsolated(this.viewFactorySearchListView);
                        this.viewFactorySearchListView = null;
                    }
                })
            }, true);
        });
    }
}

ComponentManager.setFactory('BaseTypeSelector', BaseTypeSelectorFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('BaseObjectSelector', BaseTypeSelectorFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');